import { CSSProperties } from 'react';
import { useResearchEnvironmentContext } from '@vivli/features/data-requests/infrastructure/context';
import { ButtonView } from '@vivli/shared/views';
import { Size } from '@vivli/shared/theme';
import { DTIVmProvisionedConnect } from '@vivli/shared/infrastructure/constants';

const containerStyle: CSSProperties = { marginBottom: Size.PADDING * 2 };

const buttonStyle: CSSProperties = {
    minWidth: 250,
    height: 55,
};

export const VmProvisionedConnectComponent = () => {
    const { virtualMachine } = useResearchEnvironmentContext();

    const connectToVm = () => {
        window.open(`/virtual-machine/${virtualMachine.id}/${virtualMachine.dataRequestDoi}`);
    };

    return (
        <div style={containerStyle}>
            <ButtonView onClick={connectToVm} style={buttonStyle} dataId={DTIVmProvisionedConnect.ConnectToEnvironmentButton}>
                Connect to Secure Research Environment
            </ButtonView>
        </div>
    );
};
